<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <!-- Date range picker with shortcuts for easy navigation -->
        <div style="float: right; padding: 0">
            <span style="padding: 0 5px 0 5px">{{
              this.$root.htmlConst.cons_223_aggregate_period
            }}</span>
            <el-date-picker
              v-model="datePicker"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="〜"
              :picker-options="pickerOptions"
              @change="rebuildChart('main')"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
            >
            </el-date-picker>
        </div>
      </el-row>
      <hr />
      <el-row>
        <!-- Main chart display -->
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
          @click="onClick"
        />
      </el-row>
      <!-- Popup dialog for enlarged chart view -->
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold; margin-right: 10px">{{
              displayTitle
            }}</span>
          </el-row>
          <el-row>
            <span style="padding: 0 5px 0 5px">{{
              this.$root.htmlConst.cons_223_aggregate_period
            }}</span>
            <el-date-picker
              v-model="datePicker"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="〜"
              :picker-options="pickerOptions"
              @change="rebuildChart('popup')"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
            >
            </el-date-picker>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
        />
      </el-dialog>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
var _ = require("lodash");

export default {
  name: "VoicebotCallDurationDistributionChart",
  props: ["title", "displayTitle"],
  data() {
    let _this = this;
    return {
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
      // Date picker shortcuts for quick date range selection
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datePicker: [this.$root.startDate, this.$root.endDate],
      data_list: [],
      // Duration categories for x-axis: 1-10 minutes and >10
      durationCategories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '>10'],
    };
  },
  mounted() {
    // Listen for global date change events
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.datePicker = [startDate, endDate];
      this.rebuildChart("main");
    });
  },
  created() {
    let self = this;
    self.loading = true;

    // Initial data load on component creation
    this.loadChartData('main');
  },
  methods: {
    /**
     * Load chart data from API
     * @param {string} viewType - 'main' or 'popup' to determine which loading state to update
     */
    loadChartData(viewType) {
      let self = this;
      
      if (viewType == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      // Call API to get call duration distribution data
      api.getVoicebotCallDurationDistribution(
        self.datePicker[0],
        self.datePicker[1],
        self.$root.facetForEchart,
        self.$root.ageForEchart,
        self.$root.sexForEchart
      )
      .then(
        (res) => {
          let data = res.data;
          self.data_list = data.data || [];
          
          // Process data: create a map of duration category to count
          let dataMap = {};
          self.data_list.forEach(item => {
            dataMap[item.duration_category] = parseInt(item.count) || 0;
          });
          
          // Ensure all categories have a value (0 if no data)
          let chartData = self.durationCategories.map(category => {
            return dataMap[category] || 0;
          });
          
          // Configure ECharts bar chart
          self.option = {
            color: ["#5470c6"],
            title: {
                // subtext: "件",
              },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
              formatter: function(params) {
                // Custom tooltip showing duration range and count
                let category = params[0].name;
                let count = params[0].value;
                let rangeText = '';
                
                if (category === '>10') {
                  rangeText = '10分以上';
                } else if (category === '1') {
                  rangeText = '1分以内';
                } else {
                  rangeText = `${parseInt(category)-1}分以上${category}分以内`;
                }
                
                return `${rangeText}の件数: ${count}件`;
              }
            },
            // grid: {
            //   top: "10%",
            //   bottom: "10%",
            //   left: "10%",
            //   right: "5%",
            //   containLabel: true
            // },
            xAxis: {
              type: "category",
              data: self.durationCategories,
              name: "(分)",
              nameLocation: "end",
              nameGap: 5,
              // axisLabel: {
              //   interval: 0,
              //   rotate: 0
              // }
            },
            yAxis: {
              type: "value",
              name: "件",
              // nameLocation: "top",
              // nameGap: 50,
              // minInterval: 1,
              // axisLabel: {
              //   formatter: "{value}"
              // }
            },
            series: [
              {
                name: "件",
                type: "bar",
                data: chartData,
                barWidth: "50%",
                itemStyle: {
                  color: "#5470c6",
                  borderRadius: [4, 4, 0, 0]
                },
                // label: {
                //   show: true,
                //   position: "top",
                //   formatter: "{c}"
                // }
              },
            ],
          };
          
          if (viewType == "main") {
            self.loading = false;
          } else {
            self.popupLoading = false;
          }
        },
        (err) => {
          console.log(err);
          if (viewType == "main") {
            self.loading = false;
          } else {
            self.popupLoading = false;
          }
        }
      );
    },
    
    /**
     * Show popup dialog with enlarged chart
     */
    showPopUp() {
      this.popUpDisplay = true;
    },
    
    /**
     * Rebuild chart when date range or filters change
     * @param {string} value - 'main' or 'popup' to determine which view to update
     */
    rebuildChart(value) {
      this.loadChartData(value);
    },
    
    /**
     * Handle click event on chart bars
     * Opens Redmine with filtered issues for the selected duration category
     * @param {Object} params - ECharts click event parameters
     */
    onClick(params) {
      let category = params.name;
      let ageAndSexStr = '';
      
      // Build age filter query string
      if (this.$root.ageForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
      }
      
      // Build sex filter query string
      if (this.$root.sexForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
      }
      
      // Determine duration range for Redmine filter
      // Note: This requires custom field setup in Redmine to filter by talk time duration
      let durationFilter = '';
      if (category === '>10') {
        // For >10 minutes, we need to filter talk time > 10 minutes
        // This is a placeholder - actual implementation depends on Redmine custom field configuration
        durationFilter = '&f%5B%5D=cf_43&op%5Bcf_43%5D=%3E&v%5Bcf_43%5D%5B%5D=00:10:00';
      } else {
        // For specific minute categories, filter by range
        let minMinutes = category === '1' ? 0 : parseInt(category) - 1;
        let maxMinutes = parseInt(category);
        let minTime = `00:${String(minMinutes).padStart(2, '0')}:00`;
        let maxTime = `00:${String(maxMinutes).padStart(2, '0')}:59`;
        durationFilter = `&f%5B%5D=cf_43&op%5Bcf_43%5D=%3E%3C&v%5Bcf_43%5D%5B%5D=${minTime}&v%5Bcf_43%5D%5B%5D=${maxTime}`;
      }
      
      // Open Redmine with filters applied
      window.open(
        this.$root.redmineUrl +
          "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc" +
          "&f%5B%5D=status_id&op%5Bstatus_id%5D=c" +
          "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1" +
          "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C" +
          "&v%5Bcreated_on%5D%5B%5D=" + this.datePicker[0] +
          "&v%5Bcreated_on%5D%5B%5D=" + this.datePicker[1] +
          durationFilter +
          "&f%5B%5D=cf_194&op%5Bcf_194%5D=%3D&v%5Bcf_194%5D%5B%5D=VOICE+SUPPORT" +
          "&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category" +
          "&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80" +
          "&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43" +
          "&group_by=&t%5B%5D=" +
          ageAndSexStr
      );
    },
  },
};
</script>

<style scoped>
.el-input__inner {
  height: 35px;
  line-height: 35px;
}
</style>